import { render } from "./DashboardStateCards.vue?vue&type=template&id=53c61f40&scoped=true"
import script from "./DashboardStateCards.vue?vue&type=script&lang=js"
export * from "./DashboardStateCards.vue?vue&type=script&lang=js"

import "./DashboardStateCards.vue?vue&type=style&index=0&id=53c61f40&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c61f40"]])

export default __exports__